export default function Tabs( { tabChangeHandler, selectedTab, topics }) {
  const handleChangeTab = ({id, name}) => {
    tabChangeHandler({id: id, name: name})
  }

  const className = (selectedTab, currentTab) => {
    const classNameStr = "flex-1 w-full border-b-2 px-1 py-8 text-center text-[1rem] font-medium whitespace-nowrap cursor-pointer";
    if (selectedTab.id === currentTab.id) {
      return `${classNameStr} border-primary text-primary`;
    }
    return `${classNameStr} border-transparent text-gray-700 hover:bg-gray-200`;
  }

  return (
    <div className="absolute w-full left-0 right-0">
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex">
            {topics.map((tab) => (
              <div
                key={tab.name}
                onClick={() => {handleChangeTab({name: tab.name, id: tab.id})}}
                className={className(selectedTab, tab)}
              >
                {tab.name}
              </div>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}